export default "__VITE_ASSET__DUW67X$b__"